<tp-modal [dialogTitle]="(dialogTitle$ | async)!" [isBusy]="isSubmitting$ | async">
  <tp-reauthenticate
    reauthAction="access the security center"
    [isSubmitting$]="isSubmitting$"
    (reauthStageChanged)="reauthStageChanged($event)"
  ></tp-reauthenticate>
</tp-modal>
